<script setup lang="ts">
import { type StyleValue } from 'vue';
import type { PaletteColorProp } from '#imports';

interface IProps {
    color?: PaletteColorProp | string;
    vertical?: boolean;
    borderStyle?: string;
    thickness?: string | number;
    size?: string;
    title?: string;
    titleClass?: string;
}
const {
    color = 'var(--cool-gray-200)',
    vertical,
    borderStyle = 'solid',
    thickness = 2 as string | number,
    size = '100%',
    title = '',
    titleClass = 'tg-l-700',
} = defineProps<IProps>();

const cssVariables = computed<StyleValue>(() => ({
    '--color': color,
    '--border-style': borderStyle,
    '--thickness': typeof thickness === 'number' ? `${thickness}px` : thickness,
    '--size': `${size}`,
}));
</script>

<template>
    <div class="divider-container" :class="{ vertical }" :style="cssVariables">
        <div v-if="title" class="title" :class="titleClass">
            {{ title }}
        </div>
        <hr class="divider" />
    </div>
</template>

<style lang="scss" scoped>
.divider-container {
    position: relative;
    display: flex;
    align-items: center;
    margin: var(--margin);
    width: var(--size);

    &.vertical {
        margin: var(--margin);
        width: 0;

        .divider {
            border-top: 0;
            width: 0;
            height: var(--size);
            border-right: var(--thickness) var(--border-style) var(--color);
        }
    }

    .divider {
        all: unset;
        width: var(--size);
        height: 0;
        border-top: var(--thickness) var(--border-style) var(--color);
    }

    .title {
        white-space: nowrap;
        margin-left: 8px;
    }
}
</style>
